'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { DATA_FETCHING_ERROR, LOADING } from '../problems';
import { jsx as _jsx } from "react/jsx-runtime";
export const LOADING_PROBLEM_AND_MESSAGE = {
  problem: LOADING,
  disabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "reporting-action-components.actions.loading"
  })
};
export const DATA_FETCHING_ERROR_PROBLEM_AND_MESSAGE = {
  problem: DATA_FETCHING_ERROR,
  disabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "reporting-action-components.actions.dataFetchingError"
  })
};